// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* General Uppy styles that apply to everything inside the .uppy-Root container
*/
.uppy-Root {
  position: relative;
  box-sizing: border-box;
  color: #333;
  font-family: -apple-system, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", "Segoe UI Symbol", "Segoe UI Emoji", "Apple Color Emoji", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[dir=rtl] .uppy-Root,
.uppy-Root[dir=rtl] {
  text-align: right;
}

.uppy-Root *,
.uppy-Root *::before,
.uppy-Root *::after {
  box-sizing: inherit;
}

.uppy-Root [hidden] {
  display: none;
}

.uppy-u-reset {
  animation: none 0s ease 0s 1 normal none running;
  backface-visibility: visible;
  background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
  border: medium none currentcolor;
  border-collapse: separate;
  -o-border-image: none;
     border-image: none;
  border-radius: 0;
  border-spacing: 0;
  bottom: auto;
  box-shadow: none;
  box-sizing: content-box;
  caption-side: top;
  clear: none;
  clip: auto;
  color: #000;
  -moz-columns: auto;
       columns: auto;
  -moz-column-count: auto;
       column-count: auto;
  -moz-column-fill: balance;
       column-fill: balance;
  -moz-column-gap: normal;
       column-gap: normal;
  -moz-column-rule: medium none currentcolor;
       column-rule: medium none currentcolor;
  -moz-column-span: 1;
       column-span: 1;
  -moz-column-width: auto;
       column-width: auto;
  content: normal;
  counter-increment: none;
  counter-reset: none;
  cursor: auto;
  display: inline;
  empty-cells: show;
  float: none;
  font-family: serif;
  font-size: medium;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  font-stretch: normal;
  line-height: normal;
  height: auto;
  -webkit-hyphens: none;
          hyphens: none;
  left: auto;
  letter-spacing: normal;
  list-style: disc outside none;
  margin: 0;
  max-height: none;
  max-width: none;
  min-height: 0;
  min-width: 0;
  opacity: 1;
  orphans: 2;
  outline: medium none currentcolor;
  overflow: visible;
  overflow-x: visible;
  overflow-y: visible;
  padding: 0;
  page-break-after: auto;
  page-break-before: auto;
  page-break-inside: auto;
  perspective: none;
  perspective-origin: 50% 50%;
  position: static;
  right: auto;
  -moz-tab-size: 8;
    -o-tab-size: 8;
       tab-size: 8;
  table-layout: auto;
  text-align: left;
  -moz-text-align-last: auto;
       text-align-last: auto;
  -webkit-text-decoration: none;
  text-decoration: none;
  text-indent: 0;
  text-shadow: none;
  text-transform: none;
  top: auto;
  transform: none;
  transform-origin: 50% 50% 0;
  transform-style: flat;
  transition: none 0s ease 0s;
  vertical-align: baseline;
  visibility: visible;
  white-space: normal;
  widows: 2;
  width: auto;
  word-spacing: normal;
  z-index: auto;
  all: initial;
  box-sizing: border-box;
  -webkit-appearance: none;
          -moz-appearance: none;
       appearance: none;
  font-family: -apple-system, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", "Segoe UI Symbol", "Segoe UI Emoji", "Apple Color Emoji", Roboto, Helvetica, Arial, sans-serif;
  line-height: 1;
}

[dir=rtl] .uppy-u-reset {
  text-align: right;
}

.uppy-c-textInput {
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  padding: 6px 8px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.uppy-size--md .uppy-c-textInput {
  padding: 8px 10px;
}
.uppy-c-textInput:focus {
  border-color: rgba(18, 105, 207, 0.6);
  outline: none;
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.15);
}
[data-uppy-theme=dark] .uppy-c-textInput {
  color: #eaeaea;
  background-color: #333;
  border-color: #333;
}
[data-uppy-theme=dark] .uppy-c-textInput:focus {
  border-color: #525252;
  box-shadow: none;
}

.uppy-c-icon {
  display: inline-block;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  fill: currentColor;
}

.uppy-c-btn {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  line-height: 1;
  white-space: nowrap;
  text-align: center;
  transition-duration: 0.3s;
  transition-property: background-color, color;
  -webkit-user-select: none;
          -moz-user-select: none;
       user-select: none;
}
[dir=rtl] .uppy-c-btn {
  text-align: center;
}

.uppy-c-btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.uppy-c-btn::-moz-focus-inner {
  border: 0;
}

.uppy-c-btn-primary {
  padding: 10px 18px;
  color: #fff;
  font-size: 14px;
  background-color: #1269cf;
  border-radius: 4px;
}
.uppy-c-btn-primary:not(:disabled):hover {
  background-color: #0e51a0;
}
.uppy-c-btn-primary:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.4);
}
.uppy-size--md .uppy-c-btn-primary {
  padding: 13px 22px;
}
[data-uppy-theme=dark] .uppy-c-btn-primary {
  color: #eaeaea;
}
[data-uppy-theme=dark] .uppy-c-btn-primary:focus {
  outline: none;
}
[data-uppy-theme=dark] .uppy-c-btn-primary::-moz-focus-inner {
  border: 0;
}
[data-uppy-theme=dark] .uppy-c-btn-primary:focus {
  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);
}
.uppy-c-btn-primary.uppy-c-btn--disabled {
  background-color: rgb(142, 178, 219);
}

.uppy-c-btn-link {
  padding: 10px 15px;
  color: #525252;
  font-size: 14px;
  line-height: 1;
  background-color: transparent;
  border-radius: 4px;
}
.uppy-c-btn-link:hover {
  color: #333;
}
.uppy-c-btn-link:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.25);
}
.uppy-size--md .uppy-c-btn-link {
  padding: 13px 18px;
}
[data-uppy-theme=dark] .uppy-c-btn-link {
  color: #eaeaea;
}
[data-uppy-theme=dark] .uppy-c-btn-link:focus {
  outline: none;
}
[data-uppy-theme=dark] .uppy-c-btn-link::-moz-focus-inner {
  border: 0;
}
[data-uppy-theme=dark] .uppy-c-btn-link:focus {
  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);
}
[data-uppy-theme=dark] .uppy-c-btn-link:hover {
  color: #939393;
}`, "",{"version":3,"sources":["webpack://./node_modules/@uppy/core/dist/style.css"],"names":[],"mappings":"AAAA;;CAEC;AACD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gPAAqK;EACrK,cAAc;EACd,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAY;EAAZ,4BAAY;EAAZ,iFAAY;EAAZ,gCAAY;EAAZ,yBAAY;EAAZ,qBAAY;KAAZ,kBAAY;EAAZ,gBAAY;EAAZ,iBAAY;EAAZ,YAAY;EAAZ,gBAAY;EAAZ,uBAAY;EAAZ,iBAAY;EAAZ,WAAY;EAAZ,UAAY;EAAZ,WAAY;EAAZ,kBAAY;OAAZ,aAAY;EAAZ,uBAAY;OAAZ,kBAAY;EAAZ,yBAAY;OAAZ,oBAAY;EAAZ,uBAAY;OAAZ,kBAAY;EAAZ,0CAAY;OAAZ,qCAAY;EAAZ,mBAAY;OAAZ,cAAY;EAAZ,uBAAY;OAAZ,kBAAY;EAAZ,eAAY;EAAZ,uBAAY;EAAZ,mBAAY;EAAZ,YAAY;EAAZ,eAAY;EAAZ,iBAAY;EAAZ,WAAY;EAAZ,kBAAY;EAAZ,iBAAY;EAAZ,kBAAY;EAAZ,oBAAY;EAAZ,mBAAY;EAAZ,oBAAY;EAAZ,mBAAY;EAAZ,YAAY;EAAZ,qBAAY;UAAZ,aAAY;EAAZ,UAAY;EAAZ,sBAAY;EAAZ,6BAAY;EAAZ,SAAY;EAAZ,gBAAY;EAAZ,eAAY;EAAZ,aAAY;EAAZ,YAAY;EAAZ,UAAY;EAAZ,UAAY;EAAZ,iCAAY;EAAZ,iBAAY;EAAZ,mBAAY;EAAZ,mBAAY;EAAZ,UAAY;EAAZ,sBAAY;EAAZ,uBAAY;EAAZ,uBAAY;EAAZ,iBAAY;EAAZ,2BAAY;EAAZ,gBAAY;EAAZ,WAAY;EAAZ,gBAAY;IAAZ,cAAY;OAAZ,WAAY;EAAZ,kBAAY;EAAZ,gBAAY;EAAZ,0BAAY;OAAZ,qBAAY;EAAZ,6BAAY;EAAZ,qBAAY;EAAZ,cAAY;EAAZ,iBAAY;EAAZ,oBAAY;EAAZ,SAAY;EAAZ,eAAY;EAAZ,2BAAY;EAAZ,qBAAY;EAAZ,2BAAY;EAAZ,wBAAY;EAAZ,mBAAY;EAAZ,mBAAY;EAAZ,SAAY;EAAZ,WAAY;EAAZ,oBAAY;EAAZ,aAAY;EAAZ,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;UAChB,qBAAgB;OAAhB,gBAAgB;EACxB,gPAAqK;EACrK,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,yBAAyB;UACjB,sBAAiB;OAAjB,iBAAiB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,6CAA6C;AAC/C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,+CAA+C;AACjD;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,8CAA8C;AAChD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,+CAA+C;AACjD;AACA;EACE,cAAc;AAChB","sourcesContent":["/**\n* General Uppy styles that apply to everything inside the .uppy-Root container\n*/\n.uppy-Root {\n  position: relative;\n  box-sizing: border-box;\n  color: #333;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", \"Segoe UI Symbol\", \"Segoe UI Emoji\", \"Apple Color Emoji\", Roboto, Helvetica, Arial, sans-serif;\n  line-height: 1;\n  text-align: left;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[dir=rtl] .uppy-Root,\n.uppy-Root[dir=rtl] {\n  text-align: right;\n}\n\n.uppy-Root *,\n.uppy-Root *::before,\n.uppy-Root *::after {\n  box-sizing: inherit;\n}\n\n.uppy-Root [hidden] {\n  display: none;\n}\n\n.uppy-u-reset {\n  all: initial;\n  box-sizing: border-box;\n  -webkit-appearance: none;\n          appearance: none;\n  font-family: -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", \"Segoe UI Symbol\", \"Segoe UI Emoji\", \"Apple Color Emoji\", Roboto, Helvetica, Arial, sans-serif;\n  line-height: 1;\n}\n\n[dir=rtl] .uppy-u-reset {\n  text-align: right;\n}\n\n.uppy-c-textInput {\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.5;\n  padding: 6px 8px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n.uppy-size--md .uppy-c-textInput {\n  padding: 8px 10px;\n}\n.uppy-c-textInput:focus {\n  border-color: rgba(18, 105, 207, 0.6);\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.15);\n}\n[data-uppy-theme=dark] .uppy-c-textInput {\n  color: #eaeaea;\n  background-color: #333;\n  border-color: #333;\n}\n[data-uppy-theme=dark] .uppy-c-textInput:focus {\n  border-color: #525252;\n  box-shadow: none;\n}\n\n.uppy-c-icon {\n  display: inline-block;\n  max-width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  fill: currentColor;\n}\n\n.uppy-c-btn {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n  font-size: inherit;\n  font-family: inherit;\n  color: inherit;\n  line-height: 1;\n  white-space: nowrap;\n  text-align: center;\n  transition-duration: 0.3s;\n  transition-property: background-color, color;\n  -webkit-user-select: none;\n          user-select: none;\n}\n[dir=rtl] .uppy-c-btn {\n  text-align: center;\n}\n\n.uppy-c-btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\n.uppy-c-btn::-moz-focus-inner {\n  border: 0;\n}\n\n.uppy-c-btn-primary {\n  padding: 10px 18px;\n  color: #fff;\n  font-size: 14px;\n  background-color: #1269cf;\n  border-radius: 4px;\n}\n.uppy-c-btn-primary:not(:disabled):hover {\n  background-color: #0e51a0;\n}\n.uppy-c-btn-primary:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.4);\n}\n.uppy-size--md .uppy-c-btn-primary {\n  padding: 13px 22px;\n}\n[data-uppy-theme=dark] .uppy-c-btn-primary {\n  color: #eaeaea;\n}\n[data-uppy-theme=dark] .uppy-c-btn-primary:focus {\n  outline: none;\n}\n[data-uppy-theme=dark] .uppy-c-btn-primary::-moz-focus-inner {\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-c-btn-primary:focus {\n  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);\n}\n.uppy-c-btn-primary.uppy-c-btn--disabled {\n  background-color: rgb(142, 178, 219);\n}\n\n.uppy-c-btn-link {\n  padding: 10px 15px;\n  color: #525252;\n  font-size: 14px;\n  line-height: 1;\n  background-color: transparent;\n  border-radius: 4px;\n}\n.uppy-c-btn-link:hover {\n  color: #333;\n}\n.uppy-c-btn-link:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(18, 105, 207, 0.25);\n}\n.uppy-size--md .uppy-c-btn-link {\n  padding: 13px 18px;\n}\n[data-uppy-theme=dark] .uppy-c-btn-link {\n  color: #eaeaea;\n}\n[data-uppy-theme=dark] .uppy-c-btn-link:focus {\n  outline: none;\n}\n[data-uppy-theme=dark] .uppy-c-btn-link::-moz-focus-inner {\n  border: 0;\n}\n[data-uppy-theme=dark] .uppy-c-btn-link:focus {\n  box-shadow: 0 0 0 2px rgba(170, 225, 255, 0.85);\n}\n[data-uppy-theme=dark] .uppy-c-btn-link:hover {\n  color: #939393;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
